/**
 * The Harmony mark: a navy circle with an "H" whose crossbar is a soft amber wave.
 * `inverted` draws it white-on-navy for dark backgrounds.
 */
export const BRAND = { ink: '#1E1B3A', accent: '#F0A93B', muted: '#5C5976' };

export function LogoMark({ size = 40, inverted = false }: { size?: number; inverted?: boolean }) {
  // Strokes get a little heavier at small sizes so the mark stays crisp.
  const s = size <= 32 ? 22 : size <= 56 ? 19 : 17;
  const circle = inverted ? '#FFFFFF' : BRAND.ink;
  const bars = inverted ? BRAND.ink : '#FFFFFF';
  return (
    <svg width={size} height={size} viewBox="0 0 200 200" role="img" aria-label="Harmony">
      <circle cx="100" cy="100" r="100" fill={circle} />
      <line x1="70" y1="60" x2="70" y2="140" stroke={bars} strokeWidth={s} strokeLinecap="round" />
      <line x1="130" y1="60" x2="130" y2="140" stroke={bars} strokeWidth={s} strokeLinecap="round" />
      <path d="M70 106 C 88 74, 112 128, 130 94" fill="none" stroke={BRAND.accent} strokeWidth={s - 2} strokeLinecap="round" />
    </svg>
  );
}

/** Mark + "harmony" wordmark (+ Amharic name when `amharic`). */
export function Logo({ size = 40, amharic = false, className = '' }: { size?: number; amharic?: boolean; className?: string }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <LogoMark size={size} />
      <span className="flex flex-col leading-none">
        <span className="font-bold tracking-tight text-tg-text" style={{ fontSize: size * 0.62, letterSpacing: '-0.03em' }}>
          harmony
        </span>
        {amharic && (
          <span className="mt-1 font-semibold text-tg-hint" style={{ fontSize: size * 0.26 }}>
            ሃርመኒ
          </span>
        )}
      </span>
    </span>
  );
}
